<template>
	<div class="Like">
		<div class="like-nav">
			<van-nav-bar :fixed="true">
				<template #left>
					<div class="left-text">
						<div class="logo"><img class="auto-img" src="../assets/images/coffee_icon.jpg" alt=""></div>
						<div class="logo-title">Collection</div>
					</div>
				</template>
				<template #right>
					<div class="right-text" @click="back">
						返回
					</div>
				</template>
			</van-nav-bar>
		</div>
		
		<div class="Empty">
			<van-empty description="你还没有收藏哦" v-if="collectionData.length <= 0" :image="collectImgUrl" >
			  <van-button round class="bottom-button" @click="goMenu">
				去选一些你喜欢的吧
			  </van-button>
			</van-empty>
		</div>
		
		
		<div class="Collection" v-for="(item, index) in collectionData" :key="index" @click="viewProductInfo(item.pid)" >
			<van-swipe-cell>
			  <van-card
			    :desc="item.desc"
			    :title="item.name"
			    class="goods-card"
			    :thumb="item.smallImg"
			/>
			<template #right>
			    <van-button @click='removeLike(item.pid, index)' square text="删除" type="danger" class="delete-button" />
			  </template>
			</van-swipe-cell>
		</div>
		
	</div>
</template>

<script>
	import '../assets/less/like.less'
	import {utils} from '../assets/js/utils.js'
	export default{
		data(){
			return{
				collectionData: [],
				collectImgUrl: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1598018697736&di=792073027662d0e1a631f88c5ecf52b3&imgtype=0&src=http%3A%2F%2Fpic.90sjimg.com%2Fdesign%2F00%2F05%2F78%2F29%2F5a4a5754a6900.png%2521%2Ffwfh%2F804x804%2Fquality%2F90%2Funsharp%2Ftrue%2Fcompress%2Ftrue',
			}
		},
		created() {
			this.getCollectionData();
		},
		methods:{
			
			//返回My
			back(){
				this.$router.push({name: 'My'})
			},
			
			//前往菜单
			goMenu(){
				this.$router.push({name: 'Menu'})
			},
			
			//查询全部已收藏的商品
			getCollectionData(){
				
				//检查是否有token
				let tokenString = localStorage.getItem('RETK');
				if(!tokenString){
					return
				}
				
				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})
				
				this.axios({
					methods: 'GET',
					url: '/findAllLike',
					params:{
						appkey: this.appkey,
						tokenString,
					}
				}).then(result =>{
					this.$toast.clear();
					
					if (result.data.code == 2000) {
						this.collectionData = result.data.result;
					}
				}).catch(err =>{
					this.$toast.clear();
				})
			},
					
			//查看商品详情
			viewProductInfo(pid){
				this.$router.push({name: 'Detail', query: {pid}});
			},
			
			//删除收藏数据
			removeLike(pid, index){
				//pid: 商品id
				//index: 下标
				
				//获取token字符串
				let tokenString = localStorage.getItem('RETK');
				if(!tokenString){
					this.$router.push({name: 'Login'});
					return;
				}
				
				let data = utils.queryString({
					appkey: this.appkey,
					tokenString,
					pid
				})
				
				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})
				
				this.axios({
					method: 'POST',
					url: '/notlike',
					data
				}).then(result =>{
					this.$toast.clear();
					
					if (result.data.code == 700) {
					  return this.$router.push({name: 'Login'});
					}
					
					if (result.data.code == 900) {
						this.collectionData.splice(index,1);
					}
					this.$toast(result.data.msg);
						
				}).catch(err =>{
					this.$toast.clear();
				})
			}
		}	
	}	
</script>

<style>
	.goods-card {
	    margin: 0;
	    background-color: @white;
	  }
	
	  .delete-button {
	    height: 100%;
	  }
</style>
